export const PENDING = "fetch/pending"
export const SUCCESS = "fetch/success"
export const FAILURE = "fetch/failure"